import { pipe } from 'fp-ts/function';
import { record } from 'fp-ts';

export const isMaxCapacityExceeded = (ageCategoryValues: Record<string, number>, maxCount: number) =>
    pipe(
        ageCategoryValues,
        record.reduce(0, (totalCount, count) => totalCount + count),
        (totalCount) => totalCount > maxCount
    );
